import { render, staticRenderFns } from "./ClassifyDropdown.vue?vue&type=template&id=53bc7efa&"
import script from "./ClassifyDropdown.vue?vue&type=script&lang=js&"
export * from "./ClassifyDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports